import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.object.freeze";
import { API_REQUEST } from '@/api';
import dayjs from 'dayjs';
var state = {
  data: {},
  departmentList: [],
  employments: []
};
var mutations = {
  setData: function setData(state, _ref) {
    var value = _ref.value;
    state.data = Object.freeze(value);
  },
  setDepartmentList: function setDepartmentList(state, _ref2) {
    var value = _ref2.value;
    state.departmentList = Object.freeze(value);
  },
  setUserEmployments: function setUserEmployments(state, payload) {
    state.employments = payload;
  }
};
var actions = {
  logIn: function logIn(_ref3, _ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, username, password, logInAnswer;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref3.commit;
              username = _ref4.username, password = _ref4.password;
              _context.next = 4;
              return API_REQUEST('logIn', {
                username: username,
                password: password
              });

            case 4:
              logInAnswer = _context.sent;
              return _context.abrupt("return", logInAnswer);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  logOut: function logOut(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, dispatch;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref5.commit, dispatch = _ref5.dispatch;
              _context2.next = 3;
              return API_REQUEST('logOut');

            case 3:
              commit('setData', {
                value: {}
              });
              commit('setDepartmentList', {
                value: []
              });
              dispatch('application/exit', {}, {
                root: true
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getUserEmployments: function getUserEmployments(_ref6, _ref7) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, id, _ref7$workerPositions, workerPositions, emplRes, employments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref6.commit;
              id = _ref7.id, _ref7$workerPositions = _ref7.workerPositions, workerPositions = _ref7$workerPositions === void 0 ? [] : _ref7$workerPositions;
              _context3.next = 4;
              return API_REQUEST('getEmployments', {
                'user_id': id
              });

            case 4:
              emplRes = _context3.sent;
              employments = emplRes[1].filter(function (empl) {
                var isHired = !empl.dt_hired || dayjs().diff(dayjs(empl.dt_hired), 'seconds') >= 0;
                var isFired = empl.dt_fired && dayjs().diff(dayjs(empl.dt_fired), 'seconds') >= 0;
                return isHired && !isFired;
              }).reduce(function (accumulator, empl, index, arr) {
                // only unique empls
                var foundIndex = arr.findIndex(function (item) {
                  return item['employee_id'] === empl['employee_id'];
                });
                if (foundIndex === index) accumulator.push(empl);
                return accumulator;
              }, []).map(function (empl) {
                var _workerPositions$find;

                return {
                  id: empl.employee_id,
                  tabel_code: empl.tabel_code,
                  position_name: (_workerPositions$find = workerPositions.find(function (item) {
                    return item.id === empl['position_id'];
                  })) === null || _workerPositions$find === void 0 ? void 0 : _workerPositions$find.name
                };
              });
              commit('setUserEmployments', employments);
              return _context3.abrupt("return", employments);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};
var getters = {
  isClient: function isClient(state) {
    return function (networkId) {
      if (!state.data.network || !state.data.network.outsourcings || !state.data.network.outsourcings.length) {
        return false;
      }

      return !!state.data.network.outsourcings.find(function (el) {
        return el.id === networkId;
      });
    };
  },
  outsourcings: function outsourcings(state) {
    var _state$data, _state$data$network;

    return ((_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$network = _state$data.network) === null || _state$data$network === void 0 ? void 0 : _state$data$network.outsourcings) || [];
  },
  isUserClient: function isUserClient(state) {
    var _state$data2, _state$data2$network;

    return ((_state$data2 = state.data) === null || _state$data2 === void 0 ? void 0 : (_state$data2$network = _state$data2.network) === null || _state$data2$network === void 0 ? void 0 : _state$data2$network.clients.length) === 0;
  },
  isOutsource: function isOutsource(state) {
    return function (networkId) {
      if (!state.data.network || !state.data.network.clients || !state.data.network.clients.length) {
        return false;
      }

      return !!state.data.network.clients.find(function (el) {
        return el.id === networkId;
      });
    };
  },
  isShowPositionName: function isShowPositionName(state) {
    var _state$data3, _state$data3$network;

    return !!(state !== null && state !== void 0 && (_state$data3 = state.data) !== null && _state$data3 !== void 0 && (_state$data3$network = _state$data3.network) !== null && _state$data3$network !== void 0 && _state$data3$network.get_position_from_work_type_name_in_calc_timesheet) || false;
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};